class Alert {
	constructor(element, timeout = 4000) {
		this.alert = element;
		this.timeout = timeout;

		this.registerEvents();
	}

	registerEvents() {
		this.alert.addEventListener('click', this.hide.bind(this));
	}

	show() {
		this.alert.style.transform = 'translate3d(0, 0, 0)';
		this.alert.style.pointerEvents = 'auto';

		setTimeout(() => {
			this.hide();
		}, this.timeout);
	}

	hide() {
		this.alert.style.transform = 'translate3d(0, -100%, 0)';
		this.alert.style.pointerEvents = 'none';
	}
}

export default Alert;
